<template>
  <div>
    <div
      class="box"
      v-if="discountForm.skip == 1"
      :style="{
        fontSize: discountForm.fontSize + 'px',
        color: discountForm.fontColor,
      }"
      @click="router"
    >
      跳过活动
    </div>
    <div class="bcg">
      <div class="bcg">
        <img
          :class="
            discountForm.imageDisplayMethod == 0 ? 'img heiht' : 'img over'
          "
          @click="confirmPay"
          :src="discountForm.imgUrl"
        />
        <div class="butten">
          <van-button
            @click="confirmPay"
            round
            style="width: 100%"
            type="warning"
          >
            立即订购
          </van-button>
        </div>
      </div>
      <img
        @click="confirmPays"
        class="img"
        v-if="discountForm.cardBalanceImgUrl"
        :src="discountForm.cardBalanceImgUrl"
      />
    </div>

    <!-- 支付码 -->
    <van-overlay :show="showss" @click="showss = false" z-index="2">
      <div class="wrapper3">
        <div class="block3" @click.stop>
          <div class="titles">
            支付金额：{{
              app == "0"
                ? Math.floor(
                    (discountForm.money + discountForm.cardBalance) * 100
                  ) / 100
                : discountForm.cardBalance
            }}元
          </div>
          <img
            style="width: 200px; height: 200px"
            :src="imagerurl"
            @touchend="downs"
          />
          <div class="tips">
            <div>长按二维码保存图片，或截图本页面</div>
            <div>
              打开{{ isWeiPay == 1 ? "微信" : "支付宝" }}扫一扫进行支付使用
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
  import { seriesCouponModel } from "@/api/discount";
  import { addSeriesCouponOrder, getPayList } from "@/api/newPay";

  export default {
    data() {
      return {
        //优惠方案
        discountForm: {},
        payId: "",
        //是否直接拉起支付
        isPay: 0,
        //是否是微信支付
        isWeiPay: 0,
        //支付二维码地址
        imagerurl: "",
        //支付码弹窗
        showss: false,
        //商户appId
        appId: "",
        app: "0",
      };
    },
    created() {},
    async mounted() {
      await this.seriesCouponModel();
      await this.getPayList();
    },
    methods: {
      router() {
        this.$router.push("/home");
      },
      //拉起微信支付
      weixinSDK(appid, timeStamp, package2, nonceStr, paySign, type, payType) {
        function onBridgeReady() {
          window.WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            {
              appId: appid,
              timeStamp: timeStamp,
              nonceStr: nonceStr,
              package: package2,
              signType: type,
              paySign: paySign,
              payType: payType,
            },
            function (res) {
              if (res.err_msg == "get_brand_wcpay_request:ok") {
                // 使用以上方式判断前端返回,微信团队郑重提示：
                //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                window.location.href =
                  window.location.protocol +
                  "//" +
                  window.location.host +
                  "/wap/index.html/#/about?card=" +
                  localStorage.getItem("meCardNum");
              } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
                alert("取消充值");
              } else if (res.err_msg == "get_brand_wcpay_request:fail") {
                alert("充值失败");
              }
            }
          );
        }
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener(
              "WeixinJSBridgeReady",
              onBridgeReady,
              false
            );
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
            document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
          }
        } else {
          onBridgeReady();
        }
      },
      //判断是否在微信内打开
      isWeiXin() {
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          return true;
        } else {
          return false;
        }
      },
      //获取微信信息
      wx(code, type, than) {
        function jumpLink() {
          const url = encodeURIComponent(
            window.location.protocol +
              "//" +
              window.location.host +
              "/weixinRedirectSeriesCouponOrder"
          );
          window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            than.appId +
            "&response_type=code&scope=snsapi_userinfo&redirect_uri=" +
            url;
        }
        getUserInfo();

        function getUserInfo() {
          if (code != null && code != undefined && code.trim() != "") {
            addSeriesCouponOrder(
              localStorage.getItem("meCardNum"),
              localStorage.getItem("counpomh"),
              code,
              localStorage.getItem("buttonSelection")
            ).then((res) => {
              if (res.status) {
                var s = "";
                if (than.isWeiXin() == true) {
                  s = "JSAPI";
                } else {
                  s = "MWEB";
                }
                var obj = {};
                obj = res.data.body;
                than.weixinSDK(
                  obj.appId,
                  obj.timeStamp,
                  obj.package,
                  obj.nonceStr,
                  obj.sign,
                  obj.signType,
                  s
                );
              } else {
                this.$toast(res.msg);
              }
            });
          } else {
            if (type == 1) {
              jumpLink();
            }
          }
        }
      },
      //获取支付列表
      getPayList() {
        getPayList(this.isWeiXin() ? 3 : 2).then((res) => {
          res.data.forEach((item) => {
            if (item.list.length > 0) {
              this.appId = item.list[0].appId;
              this.isWeiPay = item.id;
              this.isPay = item.list[0].code;
              this.payId = item.list[0].id;
              localStorage.setItem("counpomh", item.list[0].id);
              throw item.list[0].id;
            }
          });
        });
      },
      //确认支付
      confirmPay() {
        localStorage.setItem("buttonSelection", 0);
        this.app = localStorage.getItem("buttonSelection");
        if (this.isPay == 0 && this.isWeiPay == 1 && this.isWeiXin()) {
          this.wx(null, 1, this);
        } else {
          if (this.isPay == 0) {
            this.imagerurl =
              window.location.protocol +
              "//" +
              window.location.host +
              `/app/qrcode/qrcode?content=${encodeURIComponent(
                `${window.location.protocol}//${
                  window.location.host
                }/wap/index.html#/wechats?card=${localStorage.getItem(
                  "meCardNum"
                )}&appId=${this.appId}&payId=${this.payId}&buttonSelection=${
                  this.app
                }&biaoshi=${1}`
              )}`;
            this.showss = true;
          } else {
            this.addSeriesCouponOrder(
              localStorage.getItem("meCardNum"),
              this.payId,
              "",
              this.app
            );
          }
        }
      },
      //确认支付
      confirmPays() {
        localStorage.setItem("buttonSelection", 1);
        this.app = localStorage.getItem("buttonSelection");
        console.log(localStorage.getItem("buttonSelection"));
        console.log(this.app);
        if (this.isPay == 0 && this.isWeiPay == 1 && this.isWeiXin()) {
          this.wx(null, 1, this);
        } else {
          if (this.isPay == 0) {
            this.imagerurl =
              window.location.protocol +
              "//" +
              window.location.host +
              `/app/qrcode/qrcode?content=${encodeURIComponent(
                `${window.location.protocol}//${
                  window.location.host
                }/wap/index.html#/wechat?card=${localStorage.getItem(
                  "meCardNum"
                )}&appId=${this.appId}&payId=${this.payId}&buttonSelection=${
                  this.app
                }&discount=${1}`
              )}`;
            this.showss = true;
          } else {
            this.addSeriesCouponOrder(
              localStorage.getItem("meCardNum"),
              this.payId,
              "",
              this.app
            );
          }
        }
      },
      //拉起支付
      addSeriesCouponOrder(card, val1, val2, val3) {
        addSeriesCouponOrder(card, val1, val2, val3).then((res) => {
          if (res.status) {
            if (res.data.payType == 2) {
              window.location.href = res.data.body;
            } else if (res.data.payType == 3) {
              console.log(res.data.body);
              this.imagerurl = `/app/qrcode/qrcode?content=${encodeURIComponent(
                res.data.body
              )}`;
              this.showss = true;
            }
          } else {
            this.$toast(res.msg);
          }
        });
      },
      //下载图片
      downloadIamge(imgsrc, name) {
        //下载图片地址和图片名
        var image = new Image(); // 解决跨域 Canvas 污染问题
        image.setAttribute("crossOrigin", "anonymous");
        image.onload = function () {
          var canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          var context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);
          var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

          var a = document.createElement("a"); // 生成一个a元素
          var event = new MouseEvent("click"); // 创建一个单击事件
          a.download = name || "photo"; // 设置图片名称
          a.href = url; // 将生成的URL设置为a.href属性
          a.dispatchEvent(event); // 触发a的单击事件
        };
        image.src = imgsrc;
      }, // 改downs这个函数就行，downloadIamge（‘图片下载地址’，图片名字）
      downs() {
        // 主要是为了名字不重复
        var name = new Date().getTime();
        this.downloadIamge(this.imagerurl, `${name}`);
      },
      //获取优惠详情
      seriesCouponModel() {
        seriesCouponModel().then((res) => {
          this.discountForm = res.data;
          if (this.$route.query.code) {
            this.wx(this.$route.query.code, 0, this);
          }
        });
      },
    },
  };
</script>

<style scoped lang="scss">
  .over {
    object-fit: contain;
  }
  .heiht {
    height: 100vh;
  }
  .bcg {
    // height: 110vh;
    // position: relative;
    position: relative;
  }
  .img {
    width: 100%;
  }

  .box {
    position: absolute;
    top: 10px;
    left: 75%;
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 14px;
    background-color: transparent;
    z-index: 9999999;
  }

  .butten {
    position: absolute;
    width: 80%;
    left: 10%;
    bottom: 20px;
  }
  .wrapper3 {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 10px;

    .block3 {
      width: calc(100% - 20px);
      background-color: #fff;
      border-radius: 10px;
      position: absolute;
      bottom: 10px;
      left: 10px;
      right: 10px;
      overflow: hidden;
      .titles {
        background-color: #1b8bff;
        width: 100%;
        height: 45px;
        color: #fff;
        font-size: 18px;
        line-height: 45px;
        margin-bottom: 10px;
      }

      .tips {
        font-size: 16px;
        color: #ee0a24;
        margin-top: 10px;
        padding: 6px 0px;
        border-top: 1px solid #addaff;
        border-bottom: 1px solid #addaff;
      }
      .inBlock {
        margin: 10px;
        div {
          height: 45px;
          margin-top: 15px;
        }
        .confirmBuyBtn1 {
          background-color: #1b8bff;
          width: 100%;
          height: 45px;
          color: #fff;
          border-color: #1b8bff;
          border-radius: 10px;
        }
        .confirmBuyBtn2 {
          background-color: #ff0000;
          width: 100%;
          height: 45px;
          color: #fff;
          border-color: #ff0000;
          border-radius: 10px;
        }
      }
    }
  }
</style>
